import { jsx as s } from "react/jsx-runtime";
import { clsx as i } from "clsx";
import { forwardRef as t } from "react";
import { Pressable as e } from "../Pressable/index.js";
import f from "./Link.module.css.js";
const p = t(({ className: r, ...o }, m) => /* @__PURE__ */ s(e, { className: i(f.link, r), ref: m, ...o }));
p.displayName = "Link";
export {
  p as Link
};
//# sourceMappingURL=Link.js.map
